import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomerDetails from "../Customer_Registered_Product/CustomerDetails";
import RegisteredProductTable from "./RegisteredProductTable";
import Modal from "./Modal"; // Import the Modal component
import API_BASE_URL from "../../ApiConfig/ApiConfig";
import SearchIcon from "../../../Assets/Icon search.svg"; // Adjust the import path for the search icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from 'js-cookie';
const RegisteredProduct = () => {
  const [warranties, setWarranties] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null);
  const [selectedCustomerRecords, setSelectedCustomerRecords] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [loading, setLoading] = useState(true); // Loading state
  const [searchQuery, setSearchQuery] = useState(""); // State for search query

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10; // Number of items per page
  const token = Cookies.get('admin'); 
  // Fetch warranties data
  const fetchWarranties = async () => {
    try {
 
      const response = await axios.get(
        `${API_BASE_URL}/CustomerRegisteredProduct/fetch`,
        {
          headers: {  "Content-Type": "application/json" ,
        "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
       },  
        }
      );
      setWarranties(response.data);
      setLoading(false); // Data has been loaded
    } catch (error) {
      console.error("Error fetching warranties:", error);
      setLoading(false); // Data loading failed
    }
  };

  useEffect(() => {
    fetchWarranties();
  }, []);

  useEffect(() => {
    if (selectedCustomerId) {
      const fetchCustomerDetails = async () => {
        try {
        
          const response = await axios.get(
            `${API_BASE_URL}/api/users/customer/${selectedCustomerId}`,
            {
              headers: {  "Content-Type": "application/json" ,
            "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
           },  
            }
          );
          setSelectedCustomerDetails(response.data);
        } catch (error) {
          console.error("Error fetching customer details:", error);
        }
      };

      const fetchCustomerRecords = async () => {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/Registered/customerid/${selectedCustomerId}`,
            {
              headers: {  "Content-Type": "application/json" ,
            "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
           },  
            }
          );
          setSelectedCustomerRecords(response.data);
        } catch (error) {
          console.error("Error fetching customer records:", error);
        }
      };

      fetchCustomerDetails();
      fetchCustomerRecords();
    }
  }, [selectedCustomerId]);

  const handleView = (customerId) => {
    setSelectedCustomerId(customerId);
    setIsModalOpen(true); // Open modal when view button is clicked
  };

  const closeModal = () => {
    setIsModalOpen(false); // Close modal
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(); // Format as MM/DD/YYYY
  };

  const getUniqueCustomers = (warranties) => {
    const uniqueCustomerMap = new Map();
    warranties.forEach((warranty) => {
      if (!uniqueCustomerMap.has(warranty.customerId)) {
        uniqueCustomerMap.set(warranty.customerId, warranty);
      }
    });
    return Array.from(uniqueCustomerMap.values());
  };

  const uniqueCustomers = getUniqueCustomers(warranties); // Removed sorting

  // Filter customers based on search query
  const filteredCustomers = uniqueCustomers.filter((customer) => {
    const lowerCaseQuery = searchQuery.toLowerCase();
    return (
      customer.customerId.toLowerCase().includes(lowerCaseQuery) ||
      customer.customerName.toLowerCase().includes(lowerCaseQuery)
    );
  });

  // Pagination logic
  const indexOfLastCustomer = currentPage * perPage;
  const indexOfFirstCustomer = indexOfLastCustomer - perPage;
  const currentCustomers = filteredCustomers.slice(
    indexOfFirstCustomer,
    indexOfLastCustomer
  );

  // Calculate total number of pages
  const totalPages = Math.ceil(filteredCustomers.length / perPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="p-6 min-h-screen">
    {/* Header with Search Input */}
    <div className="flex justify-between items-center mb-8 flex-col sm:flex-row">
      <h1 className="text-3xl font-bold text-gray-800 mb-4 sm:mb-0">
        Customer Product Details
      </h1>
  
      {/* Search Input */}
      <div className="flex-shrink-0 w-full sm:w-1/3 relative">
        <input
          type="text"
          placeholder="Search by Customer ID/Name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="p-2 pl-10 pr-3 rounded-lg w-full border border-gray-300 shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300"
        />
        <img
          src={SearchIcon} // Use the search icon
          alt="Search Icon"
          className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6"
        />
      </div>
    </div>
  
    {/* Customer Data Cards */}
    <div className="container mx-auto">
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <span className="text-lg">Loading...</span>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between mb-4">
            <p className="font-semibold pl-4 text-[#87909A] w-full sm:w-auto sm:block hidden">Customer Name</p>
            <p className="font-semibold mr-28 text-[#87909A] w-full sm:w-auto sm:block hidden">Customer ID</p>
            <p className="font-semibold text-left mr-7 text-[#87909A] w-full sm:w-auto sm:block hidden">
              Action
            </p>
          </div>
  
          {currentCustomers.length > 0 ? (
            currentCustomers.map((customer, index) => (
              <div
                key={customer._id}
                className={`bg-white shadow-md rounded-lg p-4 mb-4 transition-all duration-300 ease-in-out transform ${
                  index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } group hover:bg-gray-100 hover:scale-[1.02] hover:shadow-lg hover:cursor-pointer`}
              >
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                  {/* Circle with the first letter of the customer's name */}
                  <div className="flex items-center space-x-3 ">
                    <div className="w-7 h-7 bg-[#1C50A3] text-white rounded-full flex items-center justify-center font-bold group-hover:bg-blue-600">
                      {customer.customerName.charAt(0).toUpperCase()}
                    </div>
                    <p className="text-[#292D32] font-semibold group-hover:text-blue-600">
                      {customer.customerName}
                    </p>
                  </div>
                  <p className="text-[#292D32] pl-20 font-semibold group-hover:text-blue-600">
                    {customer.customerId}
                  </p>
                  {/* Action button aligned to the right */}
                  <div className="ml-auto text-right">
                    <button
                      onClick={() => handleView(customer.customerId)}
                      className="text-[#1C50A3] bg-[#E8F1FF] rounded-lg px-4 py-1 flex items-center space-x-2 transition duration-300"
                    >
                      <i className="fas fa-eye text-sm"></i>
                      <span className="font-semibold">View</span>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No customers available</p>
          )}
        </>
      )}
    </div>
  
    {/* Pagination Controls */}
    <div className="flex justify-center items-center mt-6 space-x-3 flex-wrap">
      {/* Previous Button */}
      <button
        onClick={prevPage}
        disabled={currentPage === 1}
        className="px-4 py-2 mx-1 rounded-md disabled:opacity-50 text-gray-600 text-sm font-semibold flex items-center"
      >
        <FontAwesomeIcon icon={faChevronLeft} className="mr-2" /> Previous
      </button>
  
      {/* Page Buttons */}
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          onClick={() => handlePageChange(i + 1)}
          className={`px-3 py-1 mx-1 rounded-md text-sm font-semibold ${
            currentPage === i + 1
              ? "bg-[#1C50A3] text-white"
              : "bg-gray-200 text-gray-600"
          }`}
        >
          {i + 1}
        </button>
      ))}
  
      {/* Next Button */}
      <button
        onClick={nextPage}
        disabled={currentPage === totalPages}
        className="px-4 py-2 mx-1 rounded-md disabled:opacity-50 text-gray-600 text-sm font-semibold flex items-center"
      >
        Next <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
      </button>
    </div>
    
      {/* Modal and customer details section */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {selectedCustomerDetails && (
          <>
            <CustomerDetails details={selectedCustomerDetails} />

            <RegisteredProductTable
              records={selectedCustomerRecords}
              onViewInvoice={(invoicePath) =>
                window.open(`${API_BASE_URL}${invoicePath}`, "_blank")
              }
              formatDate={formatDate}
            />
          </>
        )}
      </Modal>
    </div>
  );
};

export default RegisteredProduct;
